angular.module("warsApp.factories").factory('errorResponseInterceptor', ['$q', 'growl', function ($q, growl) {
    var badRequest = 400;
    var unauthorized = 401;
    var forbidden = 403;
    var pageNotFound = 404;

    var responseInterceptor = {
        'responseError': function (rejection) {
            if (rejection.status !== badRequest &&
                rejection.status !== unauthorized &&
                rejection.status !== forbidden && 
                rejection.status !== pageNotFound)
            {
                if (rejection.data && typeof rejection.data == "string" && rejection.data.indexOf("has been versioned and therefore is not editable") !== -1)
                {
                    growl.addServerMessages([
                        {
                            severity: 'error',
                            title: 'Application Error',
                            text: "This Process Configuration has already been versioned and cannot be modified.  Please navigate to the new In-Work Process Configuration for this Process Type."
                        }
                    ]);
                } else {
                    growl.addServerMessages([ { severity: 'error', title: 'Application Error', text: "An unexpected error has occurred." } ]);
                }
            }
            return $q.reject(rejection);
        }
    };
    return responseInterceptor;
}]);